import React, { Component } from "react";

import { Dialog } from 'antd-mobile'
import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import WidgetPopup from "../../widget/WidgetPopup";
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';

class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            MBMS: '',
            pageInfo: {},
            optionsData: [],
            defaultValue: [],
            defaultValueStr: [],
            visible: false,
            showLabel: false,
            popupRef: null,
            userInfo: {}
        }
        this.onClickCity = this.onClickCity.bind(this)
    }
    componentDidMount() {
        // this.setState({
        //     showLabel: this.props.location.state.showLabel
        // })
        this.getUserInfo()
    }
    getUserInfo() {
        let userInfo = localStorage.getItem("_user_info_")
        let defaultValue = localStorage.getItem("defaultValue")
        let ProvincialUrbanAreas = localStorage.getItem("ProvincialUrbanAreas")
        if (userInfo) {
            let info = JSON.parse(userInfo)
            this.setState({
                userInfo: info
            })
        }
        if (defaultValue && ProvincialUrbanAreas) {
            this.onClickCity(ProvincialUrbanAreas, defaultValue)
        }
    }
    queryDimension(type, filter, code, list) {
        let obj = {
            code: type,
            hierarchy: 3,
        }
        let defaultValue = []
        let defaultValueStr = []
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/widget/dimension',
            params: {
                dimension: obj
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    data.results[0].values.forEach((da, index) => {
                        da.label = da.name
                        da.value = da.value.toString()
                        if (index === 0 && defaultValue.length === 0) {
                            defaultValue.push(da.value)
                            defaultValueStr.push(da.name)
                        }
                        da.subdimension.values.forEach((res, num) => {
                            res.label = res.name
                            res.value = res.value.toString()
                            if (num === 0 && defaultValue.length === 1) {
                                defaultValue.push(res.value)
                                defaultValueStr.push(res.name)
                            }
                            if (res.subdimension && res.subdimension.values.length) {
                                res.subdimension.values.forEach((item, i) => {
                                    if (i === 0 && defaultValue.length === 2) {
                                        defaultValue.push(item.value)
                                        defaultValueStr.push(item.name)
                                    }
                                    item.label = item.name
                                    item.value = item.value.toString()
                                })
                            }
                            res.children = res.subdimension && res.subdimension.values ? res.subdimension.values : []
                        })
                        da.children = da.subdimension.values
                    })
                    localStorage.setItem("addressInfo", JSON.stringify(data.results[0].values))
                    this.setState({
                        optionsData: data.results[0].values,
                        defaultValue: defaultValue,
                        defaultValueStr: defaultValueStr,
                    })
                    setTimeout(() => {
                        this.queryInfo(defaultValue[defaultValue.length - 1])
                    }, 400)

                    return list
                }
            }
        }, this);
    }
    queryInfo(SSQXID) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/template/info',
            params: {
                SSQXID: SSQXID
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    localStorage.setItem("_template_info_", JSON.stringify(data.result))
                    this.setState({
                        pageInfo: data.result
                    })
                } else {
                    localStorage.setItem("_template_info_", '')
                    this.setState({
                        pageInfo: {}
                    })
                }
            }
        }, this);
    }
    onPopupRef = (ref) => {
        this.popupRef = ref;
    };
    choiceCityBtn() {
        this.popupRef.LayerBtn()
    }
    onChange(value) {
        console.log(value);
    };
    confirmInfo(val, extend) {
        let item = {}
        let obj = {}
        let res = {}
        obj = this.state.optionsData.find(res => { return res.value === val[0] })
        res = obj.children.find(res => { return res.value === val[1] })
        if (val && val.length > 2) {
            item = res.children.find(res => { return res.value === val[2] })
        }
        this.setState({
            defaultValue: val,
            defaultValueStr: [obj.name, res.name, item.name]
        })
        localStorage.setItem("defaultValueList", val.join(','))
        localStorage.setItem("defaultValueStr", [obj.name, res.name, item.name].join('/'))
        this.queryInfo(val[val.length - 1])
    }
    goPage() {
        window.history.back(-1)
    }
    onClickCity(cityStr, cityValue) {
        let cityList = cityStr.split(',')
        let cityValueList = cityValue.split(',')
        this.queryInfo(cityValueList[cityValueList.length - 1])
        this.setState({
            cityName: cityList[cityList.length - 1]
        })
    }
    fillingBtn() {
        let defaultValue = localStorage.getItem("defaultValue")
        let defaultValueList = defaultValue ? defaultValue.split(',') : ''
        if (!localStorage.getItem('_user_info_')) {
            this.props.history.push({ pathname: "/home/login", state: {} });
        } else {
            WidgetAjax.ajax({
                url: Config.getBasePath() + '/businessSystem/setting',
                params: {
                    SSQXID: defaultValueList[defaultValueList.length - 1],
                    TASKID: this.state?.pageInfo?.TASKID
                },
                callback: (data) => {
                    console.log(data)
                    if (data && data.status === 0) {
                        this.setState({
                            settingInfo: data.result
                        })
                        if (data.result.STATE === '0') {
                            Dialog.alert({
                                content: '您好，当前不在申报期，无申报任务，请在申报期内申报！',
                                onConfirm: () => {
                                    console.log('Confirmed')
                                },
                            })
                            this.props.history.push({ pathname: "/home/index", state: { showLabel: true } });
                        }
                        if (data.result.SFSB === '9') {
                            Dialog.alert({
                                content: '您已参与其他年度的申报并被评定成功，感谢您的参与！',
                                onConfirm: () => {
                                
                                  this.props.history.push({ pathname: "/home/historyList", state: { settingInfo: data.result} });
                                },
                            })
                          }
                        if (data.result.SFSB === '1') {
                            this.props.history.push({ pathname: "/home/historyList", state: { showLabel: true } });
                            // this.props.history.push({ pathname: "/home/historyList", state: {} });
                        }
                        if (data.result.STATE === '1' && data.result.SFSB === '0') {
                            // this.props.history.push({ pathname: "/home/filling", state: { showLabel: true } });
                            this.props.history.push({ pathname: "/home/filling", state: { showLabel: true } });

                        }
                    }
                }
            }, this);
        }


    }
    goLoginBtn(){
        const { userInfo } = this.state;
        if(!userInfo.qrid){
            this.props.history.push({ pathname: "/home/login", state: {} });
        }else{
            this.props.history.push({ pathname: "/home/historyList", state: {} });
        }
    }
    render() {
        const { pageInfo, cityName, userInfo } = this.state
        return (
            <div data-component="history">
                <div className="sg-app-index">
                    <div className="sg-index-top">
                        <img className='sg-top-img' alt='#' src={require('../../img/business/indexBg2.png')} />
                        <div className="sg-top-label">
                            <div className="sg-top-logo">
                                <img className='sg-logo-img' alt='#' src={require('../../img/business/logo.png')} />
                            </div>
                            <div className="sg-top-options sd-spaceBetween">
                                <div className="sg-options-left sd-middle" onClick={() => { this.choiceCityBtn() }}>
                                    <img className='sg-left-img' alt='#' src={require('../../img/business/local.png')} />
                                    <div className="sg-left-font sd-fontHidden">{cityName || '北京市'}</div>
                                    <img className='sg-left-img' alt='#' src={require('../../img/business/downLine.png')} />
                                </div>
                                <div className="sg-options-right sd-end" onClick={() => { this.goLoginBtn() }}>
                                    <img className='sg-right-icon' alt='#' src={require('../../img/business/peopel.png')} />
                                    <div className="sg-right-name sd-fontHidden">{userInfo.qrid ? userInfo.entname : '您还没有登录'}</div>
                                </div>
                            </div>
                            <div className="sg-label-center">
                                <img className='sg-right-bg' alt='#' src={require('../../img/business/tipsLayer.png')} />
                                <div className="sg-center-title">申报综述</div>
                                {/* <div className="sg-center-font">
                                    <div style={{textIndent:'28px'}}>为贯彻落实《促进个体工商户发展条例》，着力提高个体工商户发展总体质量，决定在部分省份先行先试推进个体工商户分型分类精准帮扶工作。 </div>
                                    <div style={{textIndent:'28px',marginTop:'0.4rem'}}>个体工商户分类培育是对“名特优新”四类发展前景好、经营状况优、特色鲜明的个体工商户定期开展选拔认定、建立数据库、进行重点培育的措施。</div>
                                </div> */}
                                <div className="sg-center-font" dangerouslySetInnerHTML={{ __html: pageInfo.MBMS }} style={{ display: pageInfo.MBMS ? 'block' : 'none' }}></div>
                                <div className="sg-center-defined" style={{ display: !pageInfo.MBMS ? 'block' : 'none' }}>
                                    <img className='sg-defined-img' alt='#' src={require('../../img/business/defined.png')} />
                                    <div className="sg-defined-tips"></div>
                                </div>
                                <img className='sg-right-city' alt='#' src={require('../../img/business/city.png')} />
                            </div>

                        </div>
                    </div>
                    <div className="sg-app-bottom sd-middle">
                        <div className="sg-bottom-btn sd-middle" onClick={() => { this.fillingBtn() }}>开始申报</div>
                    </div>
                </div>
                <WidgetPopup onRef={this.onPopupRef} onClickCity={this.onClickCity}></WidgetPopup>
            </div>
        )
    }
}

export default Index
